(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["formas-pago"] && !Shopify.designMode) return;
  try {
    // Trigger de facilidades de pago — variante B de June Q2 Simplify PDP
let openFormas = document.getElementById('openFormasAb');
let closeFormasDePago = document.getElementById('closeFormasDePago');
let closeOverlay = document.getElementById('closeOverlay');
let formasPagoWrapper = document.getElementById('formasPagoWrapper');
let formasPago = document.getElementById('formasPago');

// ================================
// CONFIGURACIÓN
// ================================
const TRANSFER_DISCOUNT_PERCENT =  window.TRANSFER_DISCOUNT_PERCENT; // % de descuento por transferencia

// ================================
// ANIMACIONES FORMAS DE PAGO
// ================================
if (window.matchMedia('(max-width: 768px)').matches) {
  openFormas.addEventListener('click', () => {
    updateCalculations();

    formasPagoWrapper.style.display = 'flex';
    formasPago.style.right = '-300px';

    setTimeout(() => {
      formasPago.style.transition = 'all 0.5s ease-in';
      formasPago.style.right = '0px';
    }, 1);
  });

  closeFormasDePago.addEventListener('click', closeFormas);
  closeOverlay.addEventListener('click', closeFormas);
}

openFormas.addEventListener('click', () => {
  formasPagoWrapper.style.display = 'flex';
  formasPago.style.right = '-500px';

  setTimeout(() => {
    formasPago.style.transition = 'all 0.5s ease-in';
    formasPago.style.right = '0px';
  }, 1);

  document.body.classList.add('no-scroll');
});

closeFormasDePago.addEventListener('click', closeFormas);
closeOverlay.addEventListener('click', closeFormas);

function closeFormas() {
  formasPago.style.right = '-500px';
  formasPago.style.transition = 'all 0.5s ease-in';

  setTimeout(() => {
    formasPagoWrapper.style.display = 'none';
  }, 500);

  document.body.classList.remove('no-scroll');
}

// ================================
// CÁLCULOS DE VARIANTE
// ================================
document.addEventListener('DOMContentLoaded', function () {

  function formatPrice(cents) {
    return (cents / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function formatPrice(cents) {
  return (cents / 100).toLocaleString('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

function formatMoney(cents) {
  return '$' + formatPrice(cents);
}

function updateCalculations() {
  const pdpPriceElement = document.querySelector('.version-a-price [data-variant-price]');
  if (!pdpPriceElement) return;

  const priceText = pdpPriceElement.textContent || pdpPriceElement.innerText;
  const priceValue = parseFloat(priceText.replace(/[^0-9.]/g, ''));
  if (isNaN(priceValue)) return;

  const priceInCents = Math.round(priceValue * 100);

  const compareAtElement = document.querySelector('.version-a-price [data-variant-compare-at-price]');
  let compareAtInCents = 0;

  if (compareAtElement && !compareAtElement.classList.contains('hidden')) {
    const compareText = compareAtElement.textContent || compareAtElement.innerText;
    const compareValue = parseFloat(compareText.replace(/[^0-9.]/g, ''));
    if (!isNaN(compareValue)) {
      compareAtInCents = Math.round(compareValue * 100);
    }
  }

  const hasDiscount = compareAtInCents > priceInCents;

  const listPriceEl = document.querySelector('[data-formas-pago-list-price]');
  const salePriceEl = document.querySelector('[data-formas-pago-sale-price]');

  if (listPriceEl) {
    listPriceEl.textContent = hasDiscount
      ? formatMoney(compareAtInCents)
      : formatMoney(priceInCents);

    listPriceEl.classList.toggle('precio-descuento', hasDiscount);
  }

  if (salePriceEl) {
    const salePriceSpan = salePriceEl.querySelector('span') || salePriceEl;

    if (hasDiscount) {
      salePriceSpan.textContent = formatMoney(priceInCents);
      salePriceEl.style.display = '';
    } else {
      salePriceSpan.textContent = '';
      salePriceEl.style.display = 'none';
    }
  }

  const setText = (selector, value) => {
    document.querySelectorAll(selector).forEach(el => {
      el.textContent = formatMoney(value);
    });
  };

  setText('[data-variant-msi-3]', priceInCents / 3);
  setText('[data-variant-msi-6]', priceInCents / 6);
  setText('[data-variant-msi-9]', priceInCents / 9);
  setText('[data-variant-msi-12]', priceInCents / 12);
  setText('[data-variant-msi-18]', priceInCents / 18);
  setText('[data-variant-msi-24]', priceInCents / 24);
  setText('[data-variant-quincena-3]', priceInCents / 3);
  setText('[data-variant-quincena-6]', priceInCents / 6);
  setText('[data-variant-quincena-12]', priceInCents / 12);

  document.querySelectorAll('[data-msi-min]').forEach(el => {
    const min = Number(el.getAttribute('data-msi-min'));
    el.style.display = priceInCents >= min ? '' : 'none';
  });

  document.querySelectorAll('[data-variant-total]').forEach(el => {
    el.textContent = formatMoney(priceInCents);
  });

  const discountPercent = Number(TRANSFER_DISCOUNT_PERCENT || 0) / 100;
  const ahorroInCents = Math.round(priceInCents * discountPercent);
  const transferenciaInCents = priceInCents - ahorroInCents;

  const ahorroEl = document.querySelector('[data-variant-ahorro]');
  if (ahorroEl) {
    ahorroEl.textContent = formatMoney(ahorroInCents);
  }

  const transferenciaEl = document.querySelector('[data-variant-transferencia]');
  if (transferenciaEl) {
    transferenciaEl.textContent = formatMoney(transferenciaInCents);
  }

  const transferDiscountEl = document.getElementById('transferDiscount');
  if (transferDiscountEl) {
    transferDiscountEl.textContent = (TRANSFER_DISCOUNT_PERCENT || 0) + '%';
  }
}

  // ================================
  // LISTENERS VARIANTES
  // ================================
  // Actualiza el <span> junto a cada label con el valor de la variante seleccionada
  function updateSelectedVariantLabels() {
    document.querySelectorAll('[data-selected-option]').forEach(function (labelSpan) {
      var optionKey = labelSpan.getAttribute('data-selected-option');
      var selectors = document.querySelectorAll(
        '.single-option-selector[data-product-option="' + optionKey + '"]'
      );
      var value = '';

      selectors.forEach(function (selector) {
        if (selector.tagName === 'SELECT') {
          value = selector.value;
        } else if (selector.type === 'radio' && selector.checked) {
          value = selector.value;
        }
      });

      if (value) {
        labelSpan.textContent = value;
      }
    });
  }

  document.querySelectorAll('.single-option-selector').forEach(selector => {
    selector.addEventListener('change', () => {
      setTimeout(updateCalculations, 100);
      setTimeout(updateSelectedVariantLabels, 60);
    });
  });

  const bcpoSelect = document.querySelector('#bcpo-select');
  if (bcpoSelect) {
    const observer = new MutationObserver(() => {
      setTimeout(updateCalculations, 150);
    });

    observer.observe(bcpoSelect, {
      attributes: true,
      attributeFilter: ['value']
    });

    bcpoSelect.addEventListener('change', () => {
      setTimeout(updateCalculations, 150);
    });
  }

  document.addEventListener('click', event => {
    if (event.target.classList.contains('bcpo-front-button-label')) {
      setTimeout(updateCalculations, 300);
    }
  });

  document.addEventListener('change', event => {
    if (event.target.classList.contains('bcpo-front-button-option')) {
      setTimeout(updateCalculations, 250);
    }
  });

  // Inicial
  setTimeout(updateCalculations, 500);
  updateSelectedVariantLabels();
  setTimeout(updateSelectedVariantLabels, 500);
});
  } catch(e) { console.error(e); }
})();

})();
